import useApi from 'hooks/useApi';
import useCustomEvents from 'hooks/useCustomEvents';
import { webStorageUtil } from 'state/webStorage.state.service';
import { useLocalizationState } from 'state/hooks/localization.state.hook';
import { OfferData } from 'constants/apiResponses.types';
import { Checkout } from '@appcharge/shared-ui';
import { useAppState } from 'state/hooks/app.state.hook';
import { Failed } from 'pages/failed/failed';
import { OfferDataForPublisherEvent } from '../../constants/apiRequest.types';
import { useLoginState } from 'state/hooks/login.state.hook';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useCoralogixMonitoring from 'hooks/useCoralogixMonitoring';

export interface ICheckoutWrapperProps {
  close: () => void;
  selectedOffer: OfferData | OfferDataForPublisherEvent | string;
  collectId?: string;
  setLoadingFromCampaign: (value: boolean) => void;
  currencyCode: string;
  stubOffer?: boolean;
  setStubOffer: (value: boolean) => void;
}

export const CheckoutWrapper: React.FC<ICheckoutWrapperProps> = ({
  close,
  selectedOffer,
  collectId,
  setLoadingFromCampaign,
  currencyCode,
  stubOffer,
  setStubOffer,
}) => {
  const { t } = useTranslation();
  const { logToCoralogix } = useCoralogixMonitoring();
  const localization = useLocalizationState();
  const appState = useAppState();
  const customEvents = useCustomEvents();
  const loginState = useLoginState();
  const navigate = useNavigate();

  return (
    <Checkout
      customEvents={customEvents}
      logToNewRelic={logToCoralogix}
      localization={localization}
      appState={appState}
      loginState={loginState}
      webStorageUtil={webStorageUtil}
      useApi={useApi}
      t={t}
      close={close}
      selectedOffer={selectedOffer}
      collectId={collectId}
      setLoadingFromCampaign={setLoadingFromCampaign}
      currencyCode={currencyCode}
      stubOffer={stubOffer}
      setStubOffer={setStubOffer}
      Failed={Failed}
      navigate={navigate}
    />
  );
};
